module.exports = __webpack_public_path__ + "static/media/Minute Mail Logo.5a63cf74.png";